module.exports = __webpack_public_path__ + "static/img/luzhenzhong1.aa90c6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/luzhenzhong1.jpg
// module id = n/0G
// module chunks = 1